import { arrayToSimpleObj } from '../utils';

export const refundedOptions = [
  {
    text: 'All',
    value: '0',
  },
  {
    text: 'Yes',
    value: '1',
  },
  {
    text: 'No',
    value: '2',
  },
];

export const refundedMap = arrayToSimpleObj(refundedOptions);
